export type ApiVersion = 'v1' | 'v3';
export const DEFAULT_API_VERSION: ApiVersion = 'v1';
